import { render } from "./Delivery.vue?vue&type=template&id=f922ccbc"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
script.render = render

export default script